import { render, staticRenderFns } from "./LongueursAchat.vue?vue&type=template&id=3d61beaa&"
import script from "./LongueursAchat.vue?vue&type=script&lang=ts&"
export * from "./LongueursAchat.vue?vue&type=script&lang=ts&"
import style0 from "./LongueursAchat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports